export default __webpack_public_path__ + "static/media/discover.e4f11a13.png";